import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { FORM_MODIFIER } from '../../model/form.modifier';

export const UPDATE_CRITICAL_FORM_MODEL = {
  createModel: (isCritical: boolean): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'CHECKBOX',
            checked: isCritical,
            disabled: false,
            indeterminate: false,
          },
          metadata: {
            keyName: 'isCritical',
            label: 'edit_sp.Critical',
            isRequired: true,
          },
        },
      ],
    });
  },

  createModelAndGeneratePayload: (isCritical: boolean): TLiftedFormModel => {
    const formModel = UPDATE_CRITICAL_FORM_MODEL.createModel(isCritical);
    return FORM_MODIFIER.generatePayload(formModel);
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
